import store from '../../store'
import tokenService from '../../services/token.service'
import { uuid } from 'vue-uuid';

export default async (to, from, next) => {
	
	if (!tokenService.getDeviceIdFromStorage()) {
		tokenService.setDeviceIdToStorage(uuid.v4())
	}
	if (store.getters['auth/isAuthenticated']) {
		return next('/threads')
	}

	await store.dispatch('settings/getLoginSettings')
	await store.dispatch('settings/getBaseCoreSettings')

	return next()
}
